// Feedback sonoro da interface — sons curtos sintetizados via Web Audio API.
// Zero arquivos/dependencias. Respeita o toggle 'centralbabita.sfx.ativo' (default ligado).
// init() registra listeners globais: clique, hover, toggles, selects, modais, navegacao e SweetAlert.
let ctx = null;

function ativo() { try { return localStorage.getItem('centralbabita.sfx.ativo') !== 'false'; } catch { return true; } }

function ac() {
    try {
        if (!ctx) ctx = new (window.AudioContext || window.webkitAudioContext)();
        if (ctx.state === 'suspended') ctx.resume();
    } catch (_) { ctx = null; }
    return ctx;
}

// nota curta com envelope. opts: type, vol, slideTo, delay
function tone(freq, dur, opts = {}) {
    const c = ac(); if (!c) return;
    const { type = 'sine', vol = 0.05, slideTo = null, delay = 0 } = opts;
    const t0 = c.currentTime + delay;
    const osc = c.createOscillator();
    const g = c.createGain();
    osc.type = type;
    osc.frequency.setValueAtTime(freq, t0);
    if (slideTo) { try { osc.frequency.exponentialRampToValueAtTime(slideTo, t0 + dur); } catch (_) {} }
    g.gain.setValueAtTime(0.0001, t0);
    g.gain.linearRampToValueAtTime(vol, t0 + 0.008);
    g.gain.exponentialRampToValueAtTime(0.0001, t0 + dur);
    osc.connect(g).connect(c.destination);
    osc.start(t0); osc.stop(t0 + dur + 0.03);
}

const sfx = {
    click()    { if (ativo()) tone(680, 0.045, { type: 'triangle', vol: 0.035 }); },
    hover()    { if (ativo()) tone(1250, 0.022, { type: 'sine', vol: 0.014 }); },
    open()     { if (ativo()) tone(540, 0.07, { type: 'sine', vol: 0.04, slideTo: 780 }); },
    close()    { if (ativo()) tone(700, 0.07, { type: 'sine', vol: 0.035, slideTo: 460 }); },
    nav()      { if (ativo()) { tone(480, 0.06, { type: 'sine', vol: 0.03, slideTo: 720 }); tone(720, 0.08, { type: 'sine', vol: 0.025, delay: 0.05 }); } },
    toggleOn() { if (ativo()) tone(900, 0.05, { type: 'square', vol: 0.03 }); },
    toggleOff(){ if (ativo()) tone(500, 0.06, { type: 'square', vol: 0.03 }); },
    ok()       { if (ativo()) { tone(660, 0.08, { vol: 0.05 }); tone(990, 0.13, { vol: 0.05, delay: 0.07 }); } },
    warn()     { if (ativo()) { tone(540, 0.09, { type: 'triangle', vol: 0.05 }); tone(440, 0.12, { type: 'triangle', vol: 0.05, delay: 0.09 }); } },
    err()      { if (ativo()) tone(330, 0.20, { type: 'square', vol: 0.045, slideTo: 150 }); },
    toggle(v)  { try { localStorage.setItem('centralbabita.sfx.ativo', v ? 'true' : 'false'); } catch (_) {} if (v) sfx.click(); },
    ativo,
};

let inicializado = false;
function init() {
    if (inicializado || typeof document === 'undefined') return;
    inicializado = true;

    const SEL_CLIQUE = 'button, .btn, .tab, .chip, .icon-btn, .share-actions, .share-card, .sidebar-item, a[role="button"], .routine-card, .widget';

    // clique
    document.addEventListener('click', (e) => {
        if (!ativo()) return;
        const alvo = e.target.closest(SEL_CLIQUE);
        if (alvo && !alvo.closest('.swal2-popup')) sfx.click();
    }, true);

    // hover sutil (throttled p/ nao floodar)
    let ultimoHover = 0, hoverAlvo = null;
    document.addEventListener('mouseover', (e) => {
        if (!ativo()) return;
        const alvo = e.target.closest('.btn, .tab, .chip, .icon-btn, .sidebar-item, .share-card, .routine-card');
        if (!alvo || alvo === hoverAlvo || alvo.closest('.swal2-popup')) return;
        const agora = Date.now();
        if (agora - ultimoHover < 70) return;
        ultimoHover = agora; hoverAlvo = alvo;
        sfx.hover();
    }, true);
    document.addEventListener('mouseout', (e) => { if (e.target === hoverAlvo) hoverAlvo = null; }, true);

    // toggles e selects
    document.addEventListener('change', (e) => {
        if (!ativo()) return;
        const t = e.target;
        if (!t || !t.tagName) return;
        if (t.type === 'checkbox' || t.type === 'radio') { t.checked ? sfx.toggleOn() : sfx.toggleOff(); }
        else if (t.tagName === 'SELECT') sfx.click();
    }, true);

    // modais (abrir/fechar) + SweetAlert
    try {
        const obs = new MutationObserver((muts) => {
            if (!ativo()) return;
            for (const m of muts) {
                for (const n of m.addedNodes) {
                    if (n.nodeType !== 1) continue;
                    const sw = (n.classList && n.classList.contains('swal2-popup')) ? n : (n.querySelector && n.querySelector('.swal2-popup'));
                    if (sw) { setTimeout(() => { if (sw.querySelector('.swal2-success')) sfx.ok(); else if (sw.querySelector('.swal2-error')) sfx.err(); else if (sw.querySelector('.swal2-warning')) sfx.warn(); else sfx.open(); }, 30); continue; }
                    if (n.classList && (n.classList.contains('modal-mask') || n.classList.contains('modal'))) sfx.open();
                    else if (n.querySelector && n.querySelector('.modal-mask, .modal')) sfx.open();
                }
                for (const n of m.removedNodes) {
                    if (n.nodeType !== 1) continue;
                    if (n.classList && (n.classList.contains('modal-mask') || n.classList.contains('modal'))) sfx.close();
                }
            }
        });
        obs.observe(document.body, { childList: true, subtree: true });
    } catch (_) {}

    // navegacao SPA: som de transicao ao mudar de tela (wrap no pushState + popstate)
    try {
        const disparaNav = () => { if (ativo()) sfx.nav(); };
        const orig = window.history.pushState;
        window.history.pushState = function (...args) { const r = orig.apply(this, args); try { disparaNav(); } catch (_) {} return r; };
        window.addEventListener('popstate', disparaNav);
    } catch (_) {}
}

export default sfx;
export { init };
